import { cn } from '@shared/components/shadcn';
import { RichContent } from '../../../RichContent/RichContent';

type TermsAndConditionsProps = {
  information: string;
  isSmallText?: boolean;
};

/**
 * Terms and conditions lottoland section component
 * !!! Important: this component renders the T&C which we get from an editor on admin side.
 * It means that admin can setup some styles which could be different from component's default styles.
 * I strongly recomment to discuss styles with designer and manager if styles on a mock  are different from component's
 * default styles before modifying something here.
 *
 * @param information - HTML content to display as terms and conditions
 * @param isSmallText - Whether to apply small text styles
 */
function TermsAndConditions({ information, isSmallText = false }: TermsAndConditionsProps) {
  const HEADING_STYLES = isSmallText
    ? `[&_h1,_h2,_h3,_h4,_h5,_h6]:!paragraph-explanatory-strong [&_h1,_h2,_h3,_h4,_h5,_h6]:my-4 [&_p,_li,_td,_a]:!paragraph-explanatory`
    : `[&_h1,_h2,_h3,_h4]:!heading-4 [&_h1,_h2,_h3,_h4]:my-4`;
  const LIST_STYLES = `
  [&_ol]:list-none
  [&_ol]:!pl-2
  [&_ol]:[counter-reset:step]
  [&_ol]:space-y-2
  [&_ol>li]:relative
  [&_ol>li]:pl-8
  [&_ol>li]:[counter-increment:step]
  [&_ol>li::marker]:content-['']
  [&_ol>li]:before:content-[counter(step)]
  [&_ol>li]:before:absolute
  [&_ol>li]:before:left-0
  [&_ol>li]:before:w-[2ch]
  [&_ol>li]:before:text-right
  [&_ol>li]:before:text-foreground
  [&_ol>li]:before:font-normal
  [&_ol>li a]:inline
  [&_ol>li>:not(:first-child)]:ml-1
`;
  const TABLE_STYLES = `
  [&_table]:my-2
  [&_table]:w-full
  [&_table]:border
  [&_table]:border-border
  [&_table]:border-collapse
  [&_th]:border
  [&_th]:border-border
  [&_th]:px-2
  [&_th]:py-1
  [&_th]:font-medium
  [&_td]:border
  [&_td]:border-border
  [&_td]:px-2
  [&_td]:py-1
`;
  const LINK_STYLES = '[&_a]:underline [&_a]:font-bold';
  const RESPONSIVE_STYLES = 'w-full max-w-full [&_*]:break-words [&_a]:break-words [&_a]:overflow-wrap-anywhere';

  const safeInformation = information ?? '';

  return <RichContent information={safeInformation} className={cn(HEADING_STYLES, LIST_STYLES, LINK_STYLES, RESPONSIVE_STYLES, TABLE_STYLES)}></RichContent>;
}

export { TermsAndConditions, type TermsAndConditionsProps };
